import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { client, urlFor } from "../sanityClient";

// Component Banner
const BannerSection = () => {
    const [bannerData, setBannerData] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    // Fetch dữ liệu từ Sanity
    useEffect(() => {
        client
            .fetch(
                `*[_type == "banner"][0] {
          desktopImages[]{asset->{url}},
          mobileImages[]{asset->{url}}
        }`
            )
            .then((data) => setBannerData(data))
            .catch((error) => console.error("Lỗi khi lấy dữ liệu banner:", error));

        // Xác định thiết bị
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (!bannerData) return <div className="text-center py-10">Đang tải...</div>;

    const images = isMobile ? bannerData.mobileImages : bannerData.desktopImages;

    return (
        <section className="w-full h-[50vh] md:h-[65vh] overflow-hidden border-t-2 ">
            <Swiper
                modules={[ Pagination, Autoplay]}

                pagination={{ clickable: true }}
                autoplay={{ delay: 2000 }}
                loop={true}
                className="w-full h-full"
            >
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <img
                            src={urlFor(image).url()}
                            alt={`Slide ${index + 1}`}
                            className="w-full h-full object-cover"
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default BannerSection;
